import { render, staticRenderFns } from "./thirdLogin.vue?vue&type=template&id=23b5eca6"
import script from "./thirdLogin.vue?vue&type=script&lang=js"
export * from "./thirdLogin.vue?vue&type=script&lang=js"
import style0 from "./thirdLogin.vue?vue&type=style&index=0&id=23b5eca6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports